import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { supabase } from '../lib/supabase';

interface Props {
  categoryName: string;
  darkMode: boolean;
  metric?: 'members' | 'posts' | 'topics';
}

const CategoryTrendChart: React.FC<Props> = ({ categoryName, darkMode, metric = 'members' }) => {
  const [data, setData] = useState<{ date: string; value: number }[]>([]);

  useEffect(() => {
    (async () => {
      const { data: rows, error } = await supabase
        .from('category_stat_snapshots')
        .select('total_members, total_posts, total_topics, recorded_at')
        .eq('category_name', categoryName)
        .order('recorded_at', { ascending: true })
        .limit(24);
      if (error || !rows?.length) {
        setData([]);
        return;
      }
      setData(
        rows.map((r) => ({
          date: new Date(r.recorded_at).toLocaleDateString('tr-TR', { month: 'short', day: 'numeric' }),
          value:
            metric === 'posts'
              ? Number(r.total_posts)
              : metric === 'topics'
                ? Number(r.total_topics)
                : Number(r.total_members),
        }))
      );
    })();
  }, [categoryName, metric]);

  if (!data.length) {
    return (
      <p className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        Kategori trend verisi henüz yok.
      </p>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? '#374151' : '#e5e7eb'} />
        <XAxis dataKey="date" tick={{ fill: darkMode ? '#9ca3af' : '#6b7280', fontSize: 11 }} />
        <YAxis tick={{ fill: darkMode ? '#9ca3af' : '#6b7280', fontSize: 11 }} />
        <Tooltip contentStyle={{ background: darkMode ? '#1f2937' : '#fff', border: 'none' }} />
        <Line type="monotone" dataKey="value" stroke="#6366f1" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CategoryTrendChart;
